module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      translucent: _vm.isViewerMode
    }
  }, [_c('header', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/instamaps-v2-logo-flat.png",
      "alt": "Logo Instamaps",
      "title": _vm.$t('menu.home')
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "menu-main",
    attrs: {
      "id": "menu-top"
    },
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.home')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "gallery"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.gallery')))])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://betaportal.icgc.cat/wordpress/category/instamaps/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.blog')))])]), _vm._v(" "), _c('li', {
    staticClass: "videoSelectorItem",
    on: {
      "click": function($event) {
        _vm.toggleVideoSelector($event)
      }
    }
  }, [_c('div', {
    staticClass: "btn-group videoSelectorItem"
  }, [_c('button', {
    staticClass: "videoSelectorItem",
    attrs: {
      "type": "button",
      "id": "video-selector-button"
    }
  }, [_c('span', {
    staticClass: "videoSelectorItem"
  }, [_vm._v(_vm._s(_vm.$t('menu.videos')))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://betaportal.icgc.cat/wordpress/faq-dinstamaps/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.faq')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forms.office.com/r/gNusfQ0Vit",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.contact')))])]), _vm._v(" "), _c('li', {
    staticClass: "languageSelectorItem",
    on: {
      "click": function($event) {
        _vm.toggleLanguageSelector($event)
      }
    }
  }, [_c('div', {
    staticClass: "btn-group languageSelectorItem"
  }, [_c('button', {
    staticClass: "languageSelectorItem",
    attrs: {
      "type": "button",
      "id": "language-selector-button"
    }
  }, [_c('span', {
    staticClass: "languageSelectorItem"
  }, [_vm._v(_vm._s(_vm.$t('menu.language')))]), _c('i', {
    staticClass: "material-icons languageSelectorItem"
  }, [_vm._v("language")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu language-menu-item",
    attrs: {
      "id": "language-selector"
    }
  }, [_c('li', {
    staticClass: "language-menu-item",
    on: {
      "click": function($event) {
        _vm.langChange('ca')
      }
    }
  }, [_vm._v("Català")]), _vm._v(" "), _c('li', {
    staticClass: "language-menu-item",
    on: {
      "click": function($event) {
        _vm.langChange('es')
      }
    }
  }, [_vm._v("Español")]), _vm._v(" "), _c('li', {
    staticClass: "language-menu-item",
    on: {
      "click": function($event) {
        _vm.langChange('en')
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('li', {
    staticClass: "perfilSelectorItem",
    on: {
      "click": function($event) {
        _vm.togglePerfilSelector($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUserLogged),
      expression: "isUserLogged"
    }],
    staticClass: "btn-group perfilSelectorItem"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu language-menu-item",
    attrs: {
      "id": "perfil-selector"
    }
  }, [_c('li', {
    staticClass: "language-menu-item",
    on: {
      "click": function($event) {
        _vm.toProfile()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.profile')))]), _vm._v(" "), _c('li', {
    staticClass: "language-menu-item",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.logout')))])])])]), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUserLogged),
      expression: "!isUserLogged"
    }],
    staticClass: "highlighted",
    attrs: {
      "to": "login"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.login')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-button mobileMenuButton",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMobileMenuShown),
      expression: "!isMobileMenuShown"
    }],
    staticClass: "material-icons mobileMenuButton"
  }, [_vm._v("menu")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMobileMenuShown),
      expression: "isMobileMenuShown"
    }],
    staticClass: "material-icons mobileMenuButton"
  }, [_vm._v("close")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "dropdown-menu video-menu-item",
    attrs: {
      "id": "video-selector"
    }
  }, [_c('li', {
    staticClass: "video-menu-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/playlist?list=PLOe2USAqjKqD-dPVpsd5vhnNrH-XQYpAS",
      "target": "_blank"
    }
  }, [_vm._v("Vídeos de youtube")])]), _vm._v(" "), _c('li', {
    staticClass: "video-menu-item"
  }, [_c('a', {
    attrs: {
      "href": "https://betaportal.icgc.cat/wordpress/index-dajuda-als-videos-dinstamaps/",
      "target": "_blank"
    }
  }, [_vm._v("Índex d'ajuda")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "perfilSelectorBtn"
  }, [_c('span', {
    staticClass: "perfilSelectorItem"
  }), _c('i', {
    staticClass: "material-icons perfilSelectorItem"
  }, [_vm._v("account_circle")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f85bfd9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/header/header.vue
// module id = 327
// module chunks = 0